export enum LangMap {
  DE = 'de-DE',
  EN = 'en',
  ES = 'es',
  FR = 'fr',
  FI = 'fi-PH',
  ID = 'id-ID',
  IT = 'it-IT',
  CN = 'zh-CN',
  TH = 'th-TH',
  MY = 'ms-MY',
  VN = 'vi-VN',
  BR = 'pt-BR',
  PH = 'fil-PH',
  EN_GB = 'en-GB',
  ES_MX = 'es-419',
  IE = 'en-IE',
  JP = 'ja-JP',
}

const allowLanguages: string[] = [
  LangMap.DE,
  LangMap.EN,
  LangMap.EN_GB,
  LangMap.ES,
  LangMap.ES_MX,
  LangMap.FR,
  LangMap.FI,
  LangMap.ID,
  LangMap.IT,
  LangMap.CN,
  LangMap.TH,
  LangMap.MY,
  LangMap.VN,
  LangMap.BR,
  LangMap.PH,
  LangMap.JP,
];
// if (isGlobal) {
//   allowLanguages.push(LangMap.CN);
// }
export { allowLanguages };

export const languageQuery = 'oec_lng';
